import { type CSSProperties, useMemo } from 'react'
import { TreeSelect } from 'antd'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { categoryListPublicCategoriesOptions } from '@repo/sdk'

import { buildCategoryTreeNodes } from './buildCategoryTreeNodes'

interface CategorySelectProps {
  value?: string[]
  onChange?: (categoryIds: string[]) => void
  placeholder?: string
  allowClear?: boolean
  style?: CSSProperties
  'data-testid'?: string
}

export function CategorySelect({
  value,
  onChange,
  placeholder,
  allowClear = true,
  style,
  'data-testid': dataTestId,
}: CategorySelectProps): React.JSX.Element {
  const { t } = useTranslation()

  const { data, isLoading } = useQuery(categoryListPublicCategoriesOptions())

  const treeData = useMemo(() => buildCategoryTreeNodes(data?.categories ?? []), [data?.categories])

  return (
    <TreeSelect
      data-testid={dataTestId}
      multiple
      treeDefaultExpandAll
      showSearch
      treeNodeFilterProp="title"
      value={value}
      placeholder={placeholder ?? t('common.formLabels.category')}
      onChange={(selected: string[] | undefined) => onChange?.(selected ?? [])}
      allowClear={allowClear}
      style={style}
      loading={isLoading}
      treeData={treeData}
    />
  )
}
